// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","title":"title-1qt38","slider":"slider-1VaRu"};